<div class="w-full mb-2">
  @if (label) {
  <label class="text-sm font-medium text-metro-black mb-1 block">
    {{ label }}
  </label>
  }

  <div class="autocomplete-wrapper relative flex gap-1 items-center rounded-lg cursor-text pr-8 min-w-0" [ngClass]="{
    'flex-wrap': multiple,
       'input-secondary': colorVariant === 'brown-alt',
       'input-base':colorVariant === 'default',
       'focused': dropdownOpen,
       'text-base py-1.5 px-2.5': size === 'sm',
       'text-base py-2 px-3.5': size === 'md',
       'text-lg py-3 px-4.5': size === 'lg'
     }" (click)="!disabled && toggleDropdown()">

    @if (multiple) {
    @for (val of selected; track val.value) {
    <span class="flex items-center rounded-full px-3 py-1 text-sm text-white"
      [ngClass]="selectedBackgroundClass || 'bg-[#344b65]'">
      {{ val.label | abpLocalization}}
      <button type="button" class="ml-2 hover:text-red-500 text-white" (click)="removeOption(val, $event)">
        ×
      </button>
    </span>
    }

    <input #inputRef type="text" [(ngModel)]="searchTerm"
      [placeholder]="!getSelectedValuesArray().length ? placeholder : ''" class="flex-1 bg-transparent outline-none"
      [disabled]="disabled" [autocomplete]="autocomplete" />
    }

    @if (!multiple && allowSearch) {
    <input #inputRef type="text" [(ngModel)]="searchTerm" [placeholder]="placeholder"
      class="w-full bg-transparent outline-none placeholder-opacity-50" [ngClass]="{
      'bg-metro-blue text-metro-secondary placeholder-black': colorVariant === 'brown-alt',
      'bg-transparent text-metro-blue-secondary placeholder-metro-blue-secondary': colorVariant === 'default'
    }" [disabled]="disabled" (keydown)="handleKeyDown($event) " [autocomplete]="autocomplete" />
    }

    @if (!multiple && !allowSearch) {
    @if (selected.length > 0) {
    <span class="flex items-center rounded-full px-2 py-0.5 text-sm min-w-0" [ngClass]="selectedBackgroundClass">
      <span class="truncate">{{ selected[0].label | abpLocalization}}</span>
      @if (allowClear) {
      <button type="button" class="ml-2 hover:text-red-500 flex-shrink-0"
        (click)="clearSelection(); $event.stopPropagation()">
        ×
      </button>
      }
    </span>
    }

    <input #inputRef type="text" [placeholder]="selected.length === 0 ? placeholder : ''"
      class="flex-1 min-w-0 bg-transparent outline-none placeholder-opacity-50" [disabled]="disabled" [readonly]="true"
      [autocomplete]="autocomplete" [ngClass]="{
      'bg-metro-blue text-black placeholder-black': colorVariant === 'brown-alt',
      'bg-transparent text-metro-blue-secondary placeholder-metro-blue-secondary': colorVariant === 'default'}" />
    }


    <svg class="absolute right-2 h-5 w-5 text-secondary transition-transform duration-200"
      [class.rotate-180]="dropdownOpen" fill="none" viewBox="0 0 24 24" stroke="#000000">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>

    @if (filteredOptions$ | async; as options) {
    @if (dropdownOpen && options.length > 0) {
    <ul
      class="absolute left-0 top-full z-10 mt-0.5 max-h-48 w-full max-md:w-max max-md:min-w-full max-md:max-w-[80vw] overflow-y-auto overflow-x-hidden list-none m-0 p-0 rounded border bg-metro-secondary shadow-lg">
      @for (option of options; track option.value) {
      <li (click)="selectOption(option)" class="block w-full m-0 cursor-pointer px-3 py-2 break-words hover:bg-metro-blue hover:text-white"
        [class.selected]="isSelected(option)">
        {{ option.label | abpLocalization}}
      </li>
      }
    </ul>
    }
    }
  </div>

  @if (error) {
  <p class="text-[10px] text-red-500 mt-0.5 leading-none">
    {{ error | abpLocalization }}
  </p>
  }
</div>